import { QuestionBase } from './question-base.model';

export class RangeSlider extends QuestionBase<string> {
    controlType = 'range-slider';
    type: string;
    min: any;
    max: any;
    visible: boolean = true;
    constructor(options: {} = {}) {
        super(options);
        this.type = options['type'] || '';
        this.min = options['min'] || 1;
        this.max = options['max'] || 10;
        this.visible = options['visible'] != undefined ? options['visible'] : true
    }
}